import store from '@/store';

class TokenExpireInterceptor {
  static tokenExpired(error) {
    if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined && error.response.data.error === 'TokenExpired') {
      store
        .dispatch('auth/requestAccessToken')
        .then(() => {
          store.retryLastAction();
        })
        .catch(() => {});
    }
  }
}

export default TokenExpireInterceptor;
